import { Fetcher } from "@/utils/fetcher";

const gift = new Fetcher('gift');
const offer = new Fetcher('offer');
const product = new Fetcher('product');
gift.setUseToken(false);

type ApplyOfferApiResponse = {
    success: boolean;
    message?: string;
    data?: {
        subTotal?: number;
        deliveryCharge?: number;
        discountAmount?: number;
        payableAmount?: number;
        offerId?: number;
        offerType?: OfferType;
        eligibleSubtotal?: number;
    };
};

// get gift list by ids
export const getGiftListByIds = (ids: number[]) =>
    ids.length === 0 
    ? Promise.resolve([])
    : gift.post<GiftItem []>('/get-by-ids', { ids });

// search gifts for autocomplete
export const getGiftList = ({
    offset = 0,
    limit = 20,
    searchFor,
    status,
}: GiftListParams) => {
    return gift.post<GiftListResponse>('/list', {
        offset,
        limit,
        searchFor,
        status,
    });
};

// get product gift data by product ID (calls backend /product/gift/:productId)
export const getProductGifts = (productId: number) => {
    return product.get<ProductGiftResponse>(`/gift/${productId}`);
};

export const applyOffer = (couponCode: string, data: any) =>
        offer.post<ApplyOfferApiResponse>(`/apply?couponCode=${couponCode}`, data).then((response) => {
            const offerData = response.data || {};

            return {
                status: response.success,
                discountAmount: offerData.discountAmount || 0,
                payableAmount: offerData.payableAmount,
                deliveryCharge: offerData.deliveryCharge,
                subTotal: offerData.subTotal,
                eligibleSubtotal: offerData.eligibleSubtotal,
                offer: {
                    id: offerData.offerId || 0,
                } as OfferResItem,
                type: offerData.offerType || "coupon",
                message: response.message,
            } as ApplyOfferResponse;
        });